export const main_stores = {
    api: {
        login:                          '/login/',
        logout:                         '/login/logout',
        translations:                   '/lang/{lang}/translations',

        langs:                          '/lang/',
        langs_list:                     '/lang/list',
        langs_update:                   '/lang/{lang_id}',
        langs_activate:                 '/lang/activate/{lang_id}/{isactive}',

        settings_lang:                  '/settings/{lang}/get/{lng}',
        settings_lang_update:           '/settings/{lang}/update/{lng}',
        settings_lang_remove:           '/settings/{lang}/remove/{lng}',

        settings_system:                '/settings/{lang}/system/{key}',
        settings_system_key:            '/settings/{lang}/system/key/{key}',
        settings_system_file:           '/settings/{lang}/system/file/{key}',
        settings_system_update_all:     '/settings/{lang}/system/all/{key}',

        roles:                          '/roles/{lang}/',
        roles_list:                     '/roles/{lang}/list',
        roles_update:                   '/roles/{lang}/{roles_id}',

        users:                          '/users/{lang}/',
        users_update:                   '/users/{lang}/{users_id}',
        users_update_profile:           '/users/{lang}/profile/{users_id}',
        users_activate:                 '/users/{lang}/activate/{users_id}/{isactive}',
    },
    getters: {
        // ---------------------------------------------------------------------------------------------
        getLangs: (state) => () => {
            return state.api.langs;
        },
        getLangsList: (state) => () => {
            return state.api.langs_list;
        },
        getLangsUpdate: (state) => (lang_id) => {
            return state.api.langs_update.replace('{lang_id}', lang_id);
        },
        getLangsActivate: (state) => (lang_id, isactive) => {
            return state.api.langs_activate.replace('{lang_id}', lang_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getSettingsLang: (state) => (lang) => {
            return state.api.settings_lang.replace('{lang}', state.lang).replace('{lng}', lang);
        },
        getSettingsLangUpdate: (state) => (lang) => {
            return state.api.settings_lang_update.replace('{lang}', state.lang).replace('{lng}', lang);
        },
        getSettingsLangRemove: (state) => (lang) => {
            return state.api.settings_lang_remove.replace('{lang}', state.lang).replace('{lng}', lang);
        },
        getSystemSettings: (state) => (key = 'system') => {
            return state.api.settings_system.replace('{lang}', state.lang).replace('{key}', key);
        },
        getSystemSettingsKey: (state) => (key = 'system') => {
            return state.api.settings_system_key.replace('{lang}', state.lang).replace('{key}', key);
        },
        getSystemSettingsFile: (state) => (key = 'system') => {
            return state.api.settings_system_file.replace('{lang}', state.lang).replace('{key}', key);
        },
        getUpdateSystemSettingsAll: (state) => (key = 'system') => {
            return state.api.settings_system_update_all.replace('{lang}', state.lang).replace('{key}', key);
        },

        // ---------------------------------------------------------------------------------------------
        getLogin: (state) => () => {
            return state.api.login;
        },
        getLogout: (state) => () => {
            return state.api.logout;
        },
        getTranslations: (state) => () => {
            return state.api.translations.replace('{lang}', state.lang);
        },

        // ---------------------------------------------------------------------------------------------
        getRoles: (state) => () => {
            return state.api.roles.replace('{lang}', state.lang);
        },
        getRolesList: (state) => () => {
            return state.api.roles_list.replace('{lang}', state.lang);
        },
        getRolesUpdate: (state) => (roles_id) => {
            return state.api.roles_update.replace('{lang}', state.lang).replace('{roles_id}', roles_id);
        },

        // ---------------------------------------------------------------------------------------------
        getUsers: (state) => () => {
            return state.api.users.replace('{lang}', state.lang);
        },
        getUsersUpdate: (state) => (users_id) => {
            return state.api.users_update.replace('{lang}', state.lang).replace('{users_id}', users_id);
        },
        getUsersUpdateProfile: (state) => (users_id) => {
            return state.api.users_update_profile.replace('{lang}', state.lang).replace('{users_id}', users_id);
        },
        getUsersActivate: (state) => (users_id, isactive) => {
            return state.api.users_activate.replace('{lang}', state.lang).replace('{users_id}', users_id).replace('{isactive}', isactive);
        },
    },
}
